<script>
import CompanyTabLayout from '@/components/company/CompanyTabLayout.vue';
import ReportsList from '@/pages/reports/ReportsList.vue';

export default {
  components: {
    CompanyTabLayout,
    ReportsList,
  },
};
</script>

<template>
  <CompanyTabLayout active-tab="reports" v-slot="{ companyId }">
    <ReportsList :company-id="companyId" />
  </CompanyTabLayout>
</template>
